module.exports = __webpack_public_path__ + "static/media/image9.93e652b9.jpg";